export default __webpack_public_path__ + "static/media/payments_icon.3a70f505.svg";